import { THIRD_PARTY_BUSINESS, THIRD_PARTY_BUSINESS_CATEGORY, THIRD_PARTY_BUSINESS_DETAIL } from "../../constants/urls";
import { RouteObject } from "react-router-dom";

export default [
  {
    path: THIRD_PARTY_BUSINESS,
    lazy: () => import("./routes/ThirdPartyBusinessesOverview"),
  },
  {
    path: THIRD_PARTY_BUSINESS_CATEGORY,
    lazy: () => import("./routes/ThirdPartyBusinessesCategory"),
  },
  {
    path: THIRD_PARTY_BUSINESS_DETAIL,
    lazy: () => import("./routes/ThirdPartyBusinessDetail"),
  },
] as RouteObject[];
